<script>
    // Imports
    import { COLOR_LOOKUP, TEXT_COLOR_LOOKUP } from '../emotions-to-colors.js'

    // Components
    import Card from './ExpandableCard.svelte';
    import FilterButton from './FilterButton.svelte';
    import {flip} from 'svelte/animate';
    import {crossfade} from 'svelte/transition';
    const [send, receive] = crossfade({});
  
    // Props
    export let cards = [];
    export let showDirections = false;

    // Component-level settings
    let expandedCardIndex = null;
    let activeFilters = []
    let collapsing = false

    let allCardEmotions = []
    cards.forEach(card => {
        let emotions = card.emotions.split("\n")
        emotions.forEach(emotion => {
            if (allCardEmotions.indexOf(emotion.toLowerCase()) < 0) {
                allCardEmotions.push(emotion.toLowerCase())
                activeFilters.push(emotion.toLowerCase())
            }
        })
    })

    // Functions
    const onCardClick = (e, idx) => {
        if (e.keyCode && e.keyCode != 13) return
        collapsing = false
        expandedCardIndex = idx
    }

    const onButtonClick = (e, emotion) => {
        if (e.keyCode && e.keyCode != 13) return
        if (expandedCardIndex != null) {
            collapsing = true
        } else {
            collapsing = false
        }
        expandedCardIndex = null
        activeFilters = [ emotion ]
        activeCards = cards.filter(card => cardIsInFilters(card, activeFilters))
    }

    const onShowAllButtonClick = (e) => {
        if (e.keyCode && e.keyCode != 13) return
        collapsing = false
        expandedCardIndex = null
        activeFilters = allCardEmotions
        activeCards = cards
    }

    const cardIsInFilters = (card, activeFilters) => {
        const emotions = card.emotions.split("\n")
        if (!emotions || emotions.length == 0) return false

        // If any of the emotions are in the filters, return true
        return emotions.some(emotion => {
            if (activeFilters.includes(emotion.toLowerCase())) {
                return true
            }
        })
    }

    let activeCards = cards.filter(card => cardIsInFilters(card, activeFilters))

    const animation = (node, obj, options) => {
        if (collapsing) {
            return flip(node, obj, {
                duration: 0
            })
        }
        if (expandedCardIndex == null) {
            return flip(node, obj, {
                duration: 200
            })
        } else {
            return flip(node, obj, {
                duration: 0
            })
        }
    }

    const collapseCards = (e) => {
        collapsing = true
        expandedCardIndex = null
    }
</script>

{#if showDirections}
<div class="directions-container">
    <p>Select a card to see more about the lost item. Choose an emotion to filter the submissions.</p>
</div>
{/if}

<div class="filter-button-container">
    <div class="button-wrapper" 
        on:click={ (e) => onShowAllButtonClick(e) } 
        on:keydown= { (e) => onShowAllButtonClick(e) }
    >
        <FilterButton
            emotion={ "Show All" }
            color={ '#C4C1A0' } 
            textColor={ '#222 '}
            isToggled={ (activeFilters.length == allCardEmotions.length) }
            isGrayedOut={ (activeFilters.length == allCardEmotions.length) }
            />
    </div>

    {#each allCardEmotions as emotion, idx}
        <div class="button-wrapper"
            on:click={ (e) => onButtonClick(e, emotion.toLowerCase()) } 
            on:keydown= { (e) => onButtonClick(e, emotion.toLowerCase()) }
        >
            <FilterButton
                emotion={ emotion }
                color={ COLOR_LOOKUP[emotion.toLowerCase()] } 
                textColor={ TEXT_COLOR_LOOKUP[emotion.toLowerCase()] }
                isToggled={ activeFilters.includes(emotion.toLowerCase()) }
                />
        </div>
    {/each}
</div>


<div class="card-container">
    {#each activeCards as card, idx (card)}
        <div 
            class="card-wrapper { expandedCardIndex == idx ? 'is-expanded' : '' }"
            on:click={ (e) => onCardClick(e, idx) } 
            on:keydown= { (e) => onCardClick(e, idx) }
            animate:animation
            in:receive={{key: card}}
            out:send={{key: card}}
            tabindex="0"
            aria-label="Select card to expand"
            role="button"
            aria-pressed="{ (expandedCardIndex == idx) ? "true" : "false" }"
        >
            <Card {...card} isExpanded={ expandedCardIndex == idx } on:closed={ (e) => { collapseCards() }} />
        </div>
    {/each}
</div>

<svg width="0" height="0" style=""> 
    <filter id="filter">
      <feTurbulence type="fractalNoise" baseFrequency=".01" numOctaves="10" />
      <feDisplacementMap in="SourceGraphic" scale="3" />
    </filter>
</svg>